import { call, put, takeLatest } from "redux-saga/effects";
import {
  editDepartmentStart,
  editDepartmentFailure,
  editDepartmentSuccess,
} from "../reducer";
import { networkErrorHandler } from "../../../utils/errorHandlers";
import { httpEditDepartment } from "../../../services/department";
import { successNotifier } from "../../../utils/helpers";

export function* editDepartment({ payload }) {
  const { data, callback } = payload;
  const response = yield call(httpEditDepartment, data);
  const { success, raw, message } = response;

  if (success) {
    yield put(editDepartmentSuccess());
    successNotifier("Department edited successfully");
    if (callback) {
      callback();
    }
  } else {
    yield put(editDepartmentFailure(message || raw?.error));
    networkErrorHandler(response?.statusCode, message || raw?.error);
  }
}

export default function* onEditDepartment() {
  yield takeLatest(editDepartmentStart.type, editDepartment);
}
